export const sapBindingKeys = {
  allProject: ["sapProjBindings"] as const,
  allUser: ["sapUserBindings"] as const,
  allOrg: ["sapOrgBindings"] as const,
  org: (orgId: string) => [...sapBindingKeys.allOrg, "organization", orgId] as const,
  project: (projectId: string) => [...sapBindingKeys.allProject, "project", projectId] as const,
  user: (userId: string) => [...sapBindingKeys.allUser, "user", userId] as const,
};
